import React from 'react';
import { Modal, Button } from 'tea-component';

const DeleteSetting = (props: any) => {
  const { visible, close, deletedFilter, deleteFilterSaveFetch } = props;
  // const { name } = deletedFilter;

  const deleteSelectorScheme = () => {
    deleteFilterSaveFetch(deletedFilter, () => {});
    close?.();
  };

  return (
    <Modal visible={visible} caption="" onClose={close} className={'dbg-delete-save-filter-modal'}>
      <Modal.Body>
        <div className="deleteSetting-title">{'Delete the filter setting?'}</div>
        <div className="deleteSetting-desc">
          {'Do you want to delete?'}
          {/* <span className="dbd_filter_save_delete_name">{'Do you want to delete?'}</span> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={deleteSelectorScheme}>
          {'Confirm'}
        </Button>
        <Button type="weak" onClick={close}>
          {'Cancel'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSetting;
